import $ from 'jquery';
import '@accessible360/accessible-slick';
import '@accessible360/accessible-slick/slick/accessible-slick-theme.min.css';

document.addEventListener('DOMContentLoaded', () => {
	for (const element of document.querySelectorAll(".statistic-carousel__items")) {
		($(element) as any).slick({
			slidesToShow: 1,
			autoplay: true,
			vertical: true,
			useAutoplayToggleButton: false,
			arrows: false,
			adaptiveHeight: false,
			verticalSwiping: true,
		});

		function setEqualSlideHeights() {
			for (const slide of element.querySelectorAll<HTMLElement>(".slick-slide")) {
				slide.style.height = "auto";
			}
			let maxHeight = 0;

			for (const slide of element.querySelectorAll<HTMLElement>(".slick-slide")) {
				const style = window.getComputedStyle(slide);
				const slideHeight = (parseFloat(style.height) + parseFloat(style.marginTop) + parseFloat(style.marginBottom) + parseFloat(style.borderTop) + parseFloat(style.borderBottom)) || 0;
				if (slideHeight > maxHeight) {
					maxHeight = slideHeight;
				}
			}

			for (const slide of element.querySelectorAll<HTMLElement>(".slick-slide")) {
				slide.style.height = `${maxHeight}px`;
			}
		}

		setEqualSlideHeights();

		// Doesn't work
		// This carousel doesn't re-format correctly on resize by default though
		// window.addEventListener('resize', debounce(setEqualSlideHeights));
	}
});
